var exports = {
  "iE": "xa15a2ab7--c5ef4d--wrapper",
  "lB": "xa15a2ab7--c5ef4d--span-columns",
  "ZZ": "xa15a2ab7--c5ef4d--field",
  "nf": "xa15a2ab7--c5ef4d--link",
};

module.exports = exports;
